import { render, staticRenderFns } from "./OpsNoticeBoard.vue?vue&type=template&id=394de6ae&scoped=true&"
import script from "./OpsNoticeBoard.vue?vue&type=script&lang=js&"
export * from "./OpsNoticeBoard.vue?vue&type=script&lang=js&"
import style0 from "./OpsNoticeBoard.vue?vue&type=style&index=0&id=394de6ae&scoped=true&lang=css&"
import style1 from "./OpsNoticeBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394de6ae",
  null
  
)

export default component.exports